import images from "../../../data/images.json";

type Image = {
  id: string;
  type: string;
  src: string;
  alt: string;
  width: number;
  height: number;
};

export function getImage(id: string): Image | null {
  return (images.find((image) => image.id === id) as Image) || null;
}

export function getImageIdsWithType(type: string): string[] {
  return images.filter((image) => image.type === type).map(({ id }) => id);
}
